import Card from './CardWithTitleAndButton'

export default Card
